/**
 * 加药状态
 */

import {
    Style
} from '@/libs/style.js';

let template = /*html*/ `
<div class="chemical-status">
    <div class="chemical-status-header">
        <img src="./images/default/2.png" alt="">
        <h4>加药统计</h4>
    </div>
    <dv-conical-column-chart-1 :config="JSON.stringify(config)" style="height:100%;" />
    
</div>`;


let style = /* css */ `.chemical-status{
    position: absolute;
    top:calc(290px + 100px);;
    right: 1%;
    width: 25%;
    height: 270px;
    overflow: hidden;
}

.chemical-status .chemical-status-header{
    background:linear-gradient(to right,#67BDFF,rgba(0,0,0,0) 50%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center
}
.chemical-status .chemical-status-header img{
    margin:0 15px;
}
`;

export default (Vue) => {
    Vue.customElement('chemical-status-monitoring', {
        template: template,
        data() {
            return {
                config: {
                    data: [{
                            name: 'PAC',
                            value: 55
                        },
                        {
                            name: 'PAM',
                            value: 120
                        },
                        {
                            name: '碳源',
                            value: 71
                        },
                        {
                            name: '次杨酸钠',
                            value: 90
                        }
                    ],
                    showValue: true,
                }
            }
        },
        mounted() {
            Style(style);
        }
    });
}